import _createForOfIteratorHelper from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import r from "../../shared-lib/braze-shared-lib.js";
import { decodeBrazeActions as $t } from "./string-utils.js";
import { BRAZE_ACTION_URI_REGEX as O, isValidBrazeActionType as to, isValidBrazeActionJson as P } from "./validation-utils.js";
export var BRAZE_ACTIONS = {
  types: {
    ue: "container",
    logCustomEvent: "logCustomEvent",
    setEmailNotificationSubscriptionType: "setEmailNotificationSubscriptionType",
    setPushNotificationSubscriptionType: "setPushNotificationSubscriptionType",
    setCustomUserAttribute: "setCustomUserAttribute",
    requestPushPermission: "requestPushPermission",
    addToSubscriptionGroup: "addToSubscriptionGroup",
    removeFromSubscriptionGroup: "removeFromSubscriptionGroup",
    addToCustomAttributeArray: "addToCustomAttributeArray",
    removeFromCustomAttributeArray: "removeFromCustomAttributeArray",
    de: "openLink",
    pe: "openLinkInWebView"
  },
  properties: {
    type: "type",
    me: "steps",
    fe: "args"
  }
};
export var INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES = {
  We: "unknownBrazeAction",
  Ye: "noPushPrompt"
};
export var ineligibleBrazeActionURLErrorMessage = function ineligibleBrazeActionURLErrorMessage(t, o) {
  switch (t) {
    case INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES.We:
      return "".concat(o, " contains an unknown braze action type and will not be displayed.");

    case INELIGIBLE_BRAZE_ACTION_URL_ERROR_TYPES.Ye:
      return "".concat(o, " contains a push prompt braze action, but is not eligible for a push prompt. Ignoring.");

    default:
      return "";
  }
};
export function getDecodedBrazeAction(t) {
  try {
    var o = t.match(O)[0].length;
    var e = t.substring(o);
    if (o > t.length - 1 || !e) return void r.D.error("Did not find base64 encoded brazeAction in url to process : ".concat(t));
    var n = $t(e);
    return n ? JSON.parse(n) : void r.D.error("Failed to decode base64 encoded brazeAction: ".concat(e));
  } catch (o) {
    return void r.D.error("Failed to process brazeAction URL ".concat(t, " : ").concat(o.message));
  }
}

function oo(t, o) {
  var r = !1;

  var _iterator = _createForOfIteratorHelper(o),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var e = _step.value;
      if (r = r || t(e), r) return !0;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return !1;
}

export function containsUnknownBrazeAction(t) {
  try {
    var o = t[BRAZE_ACTIONS.properties.type];
    return o === BRAZE_ACTIONS.types.ue ? oo(containsUnknownBrazeAction, t[BRAZE_ACTIONS.properties.me]) : !to(o);
  } catch (t) {
    return !0;
  }
}
export function containsPushPrimerBrazeAction(t) {
  if (!P(t)) return !1;
  var o = t[BRAZE_ACTIONS.properties.type];
  return o === BRAZE_ACTIONS.types.ue ? oo(containsPushPrimerBrazeAction, t[BRAZE_ACTIONS.properties.me]) : o === BRAZE_ACTIONS.types.requestPushPermission;
}